export const customerRatings = [
  {
    customerName: 'Lade',
    image: 'https://i.pravatar.cc/50?img=1',
    comment:
      "I don't want to invest in separate stocks because I'm not a financial expert and I would rather trust my money in the hands of people like Rise who are skilled and knowledgeable.",
    job: 'UX Researcher',
  },
  {
    customerName: 'Jesse',
    image: 'https://i.pravatar.cc/50?img=2',
    comment:
      "I don't want to invest in separate stocks because I'm not a financial expert and I would rather trust my money in the hands of people like Rise who are skilled and knowledgeable.",
    job: 'UX Analyst',
  },
  {
    customerName: 'Raye',
    image: 'https://i.pravatar.cc/50?img=3',
    comment:
      'I chose Rise because of its leadership, wealth of knowledge and the people who support them. I invest with Rise in order to protect my savings and investment from being depleted by devaluation and inflation that’s at an all-time high in Nigeria.',
    job: 'UX Researcher',
  },
  {
    customerName: 'John',
    image: 'https://i.pravatar.cc/50?img=4',
    comment:
      "I don't want to invest in separate stocks because I'm not a financial expert and I would rather trust my money in the hands of people like Rise who are skilled and knowledgeable.",
    job: 'UX Researcher',
  },
  {
    customerName: 'Gabriel',
    image: 'https://i.pravatar.cc/50?img=5',
    comment:
      'I chose Rise because of its leadership, wealth of knowledge and the people who support them. I invest with Rise in order to protect my savings and investment from being depleted by devaluation and inflation that’s at an all-time high in Nigeria.',
    job: 'UX Researcher',
  },
];
